











import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class UDefaultBadge extends Vue {
  @Prop({ required: true })
  public object!: string;
  // Computed
  public get label() {
    return this.$i18n.t("_.default_object", {
      object: this.object.toLowerCase()
    });
  }
}
